import { render, staticRenderFns } from "./budget-gkkp-sum-calc-table.vue?vue&type=template&id=0cb0c621&scoped=true&"
import script from "./budget-gkkp-sum-calc-table.vue?vue&type=script&lang=ts&"
export * from "./budget-gkkp-sum-calc-table.vue?vue&type=script&lang=ts&"
import style0 from "./budget-gkkp-sum-calc-table.vue?vue&type=style&index=0&id=0cb0c621&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0c621",
  null
  
)

export default component.exports